import get from "lodash/get";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const defaultResourceParams = {
  sort: {
    field: "id",
    order: "desc",
  },
  filter: {},
  pagination: {
    page: 1,
    perPage: 10,
  },
};

export const defaultResourceList = {
  total: 0,
  ids: [],
  loadedOnce: false,
  loading: null,
  params: null,
};

export const useResource = (resource) => {
  return useSelector((state) => state?.resources?.[resource] || null);
};

export const useResourceData = (resource) => {
  return useSelector((state) => state?.resources?.[resource]?.data || null);
};

export const useResourceList = (resource, location, componentId) => {
  return useSelector((state) =>
    get(
      state,
      `resources.${resource}.${location}.${componentId}.list`,
      defaultResourceList
    )
  );
};

export const useList = (
  resource,
  location = "default",
  componentId = "default",
  params = defaultResourceParams
) => {
  const version = useSelector((state) => state.ui.viewVersion);
  const data = useResourceData(resource);
  const list = useResourceList(resource, location, componentId);

  // generate data list based on filtered ids
  const pageData = useMemo(() => list.ids
    .map((id) => data[id] || null)
    .filter((d) => d !== null)
    , [list.ids, data]);

  return useMemo(() => ({
    data: data,
    pageData: pageData,
    params: list.params || params,
    total: list.total,
    ids: list.ids,
    loadedOnce: list.loadedOnce,
    isLoading: list.loading,
    version: version,
  }), [data, pageData, list, params, version]);
};

export const getListHook = useList;

export default useList;
